<script setup lang="ts">
import { useLocale } from '../../../composables/useLocale';
import { EnumFilter } from '../types';

const { t } = useLocale();

type Props = {
  name: string;
  filter: EnumFilter;
};
defineProps<Props>();
const model = defineModel<string[]>();
const emit = defineEmits(['update:modelValue']);

const valueUpdated = (value: string[]) => {
  emit('update:modelValue', value.length > 0 ? value : undefined);
};
</script>

<template>
  <v-chip-group :model-value="model" column :multiple="filter.multiple" @update:modelValue="valueUpdated">
    <v-chip
      v-for="option in filter.options"
      :key="option"
      :value="option"
      :append-icon="Array.isArray(model) && model.includes(option) ? 'mdi-close' : ''"
      :class="{
        'bg-primary-container': Array.isArray(model) && model.includes(option),
      }"
    >
      {{ t(`lcp.${option}`) }}
    </v-chip>
  </v-chip-group>
</template>
